import {
  IOpenBankingStatus,
  OpenBankingStatus as OpenBankingStatusEnum,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class OpenBankingStatus implements IOpenBankingStatus {
  status!: OpenBankingStatusEnum;
  @Type(() => Date)
  expirationDate!: Date | null;
}
